var map = {
	"./Hummingbird-Main-Logo-HIGH-RES.png": 6175,
	"./Robertas_Logo.jpg": 6363,
	"./alvaradostreetbakery.png": 3718,
	"./automated-allergens.png": 6074,
	"./bakery-costs.png": 1600,
	"./bakery-hero.png": 7217,
	"./boltiful2.png": 139,
	"./bulkdownload.png": 8543,
	"./carolinacopacking-logo.png": 330,
	"./copacker-costing.png": 1162,
	"./copacker-hero.png": 8177,
	"./funnyface.png": 7262,
	"./manressabread.png": 2969,
	"./michaelfoods-logo.png": 2339,
	"./nb-logo.webp": 3856,
	"./pure-green-logo.svg": 1103,
	"./restaurant-allergens.png": 5330,
	"./restaurant-costs.png": 1977,
	"./restaurant-hero.png": 9738,
	"./restaurant-menu-nutrition.png": 293,
	"./restaurant-subrecipe.png": 5181,
	"./scaling.png": 4473,
	"./subrecipe.png": 4516,
	"./thirdculture.png": 6972,
	"./treehouse-logo.png": 2202,
	"./yield-adjustments.png": 7597
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1169;